import React, { Component } from 'react'
import {  Route } from 'react-router-dom'
import { connect } from 'react-redux';

import PageListHeader from '../../components/contents/page/PageListHeader'
import PageList from '../../components/contents/page/PageList'
import Pagination from '../../components/common/Pagination'
import { parseListParams } from '../../components/common/EntryListHelper';
import ListWriteTitle from "../../components/common/list/ListWriteTitle";

@connect(state => ({
    items: state.page.item.items,
    totalCount: state.page.item.totalCount,
    searchKeyword: state.page.condition.searchKeyword,
}))
class PageApp extends Component {

	render() {

        const { totalCount, searchKeyword } = this.props;

		return (
				<div className="inner_article contents_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
					<ListWriteTitle type="page" headLabel="페이지" totalCount={totalCount} searchKeyword={searchKeyword}/>
					<Route path="/pages" exact={false} strict={false} component={PageListHeader}/>
					<Route path="/pages" exact={false} strict={false} component={PageList}/>
					<Pagination totalCount={totalCount} parseListParams={parseListParams}/>
				</div>
		)
	}
}

export default PageApp
